<template>
    <div class="view-wrapper">
        <transition-group>
            <v-top-images key="images"></v-top-images>
            <!-- main page -->
            <div class="page-wrapper" v-show="currentForm===0" key="main">
                <v-intro-text></v-intro-text>
                <v-form :formdef="forms.main.def" v-model="forms.main.state" :errors="forms.main.errors" @clearerror="forms.main.errors[$event]=null;hasError=false"></v-form>
                <v-inbetween-text></v-inbetween-text>
                <div v-if="!isLoading" style="overflow:hidden">
                    <div class="warntext" v-if="hasError">Please make sure you filled out all fields and accepted the GDPR policy.</div>
                    <button v-if="has_abstract" @click="submit_request(false, false, 1)" class="btn-primary right">To abstract<i class="fa fa-arrow-right"></i></button>
                    <button v-else              @click="submit_request(false, true, 2)" class="btn-primary right">Submit<i class="fa fa-arrow-right"></i></button>
                </div>
                <div v-else>
                    <button class="btn-primary right loading"><i class="fa fa-spinner fa-spin"></i></button>
                </div>
                <div v-if="isAdmin" style="float: right"><input type="checkbox" id="forceAbstractCheckbox" v-model="forceAbstract"  /><label for="forceAbstractCheckbox">(ADMIN) Add abstract anyway</label></div>
            </div>

            <!-- abstract page -->
            <div class="page-wrapper" v-show="currentForm===1" key="abstract">
                <v-form :formdef="forms.abstract.def" v-model="forms.abstract.state" :errors="forms.abstract.errors" @clearerror="forms.abstract.errors[$event]=null;hasError=false"></v-form>
                <div v-if="!isLoading">
                    <div class="warntext" v-if="hasError">Please make sure you filled out all fields and accepted the GDPR policy.</div>
                    <button class="btn-primary" @click="currentForm=0"><i class="fa fa-arrow-left"></i>Go back</button>
                    <button class="btn-primary right" @click="submit_request(true, true, 2)">Submit<i class="fa fa-arrow-right"></i></button>
                </div>
                <div v-else>
                    <button class="btn-primary right loading"><i class="fa fa-spinner fa-spin"></i></button>
                </div>
            </div>

            <!-- confirm page -->
            <div class="page-wrapper" v-show="currentForm===2" key="confirmed">
                <v-thankyou-text></v-thankyou-text>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import vForm from '@/components/form/v-form.vue'
    import mainFormDef from '@/assets/formdef_main.json'
    import abstractFormDef from '@/assets/formdef_abstract.json'
    import vTopImages from '@/components/vtopimages.vue'
    import vInbetweenText from '@/components/vinbetweentext.vue'
    import vThankyouText from '@/components/vthankyoutext.vue'
    import vIntroText from '@/components/vintrotext.vue'
    export default {
        name: 'v-mainform',
        components:{
            'v-form':vForm,
            'v-intro-text':vIntroText,
            'v-inbetween-text':vInbetweenText,
            'v-thankyou-text':vThankyouText,
            'v-top-images':vTopImages
        },
        data(){
            return{
                'currentForm':0,
                'isLoading':false,
                'hasError':false,
                'isAdmin':false,
                'forceAbstract':false,

                'forms':{
                    'main':{
                        'def':mainFormDef,
                        'state': mainFormDef.reduce((acc, field) => ({
                            ...acc,
                            [field.name]: null,
                        }), {}),
                        'errors':{}
                    },
                    'abstract':{
                        'def':abstractFormDef,
                        'state': abstractFormDef.reduce((acc, field) => ({
                            ...acc,
                            [field.name]: null,
                        }), {}),
                        'errors':{}
                    }
                }
            }
        },
        computed:{
            has_abstract(){
                if(this.forceAbstract === true) return true;
                if(this.forms.main.state == {}) return false;
                if(this.forms.main.state['function'] == 'PhD student') return true;
                if(this.forms.main.state['function'] == 'Master Oncology student') return true;
                if(this.forms.main.state['function'] == 'Post doc') {
                    if (this.forms.main.state['presentation_preference'] == 'No presentation (can NOT be chosen by PhD students)') return false;
                    return true;
                }
                if(this.forms.main.state['function'] == 'Other;') {
                    if (this.forms.main.state['presentation_preference'] == 'No presentation (can NOT be chosen by PhD students)') return false;
                    return true;
                }
                return false;
            }
        },
        methods:{
            submit_request(has_abstract, save, nextPage){
                var ctx = this;
                var formName = has_abstract ? 'abstract' : 'main';
                ctx.isLoading = true;
                var payload = {
                    'has_abstract':has_abstract,
                    'save':save,
                    'data':{'main':ctx.forms.main.state, 'abstract':ctx.forms.abstract.state}
                }

                const editId = this.$route.params.editId;
                const endpoint = (editId === undefined) ? '/endpoint/' : `/endpoint/${editId}/`;

                this.axios.post(endpoint, payload)
                .then(function(response){
                    //Success
                    ctx.isLoading = false;
                    ctx.currentForm = nextPage;
                })
                .catch(function(error) {
                    if(!error.response.data || error.response.status != 400){
                        alert('Incorrect server response, please try reloading the page.');
                        ctx.isLoading = false;
                        return
                    }
                    //Scroll to first error
                    ctx.$set(ctx.forms[formName], 'errors', error.response.data);
                    var firstError = Object.keys(error.response.data)[0]
                    ctx.hasError = true;
                    ctx.$scrollTo('#field_'+firstError, 1000);
                    ctx.isLoading = false;
                });
            }
        },
        mounted() {
            const editId = this.$route.params.editId;
            if (editId !== undefined) {
                var ctx = this;
                ctx.isLoading = true;
                this.axios.get(`/endpoint/${editId}`)
                .then(function(response){
                    //Success
                    ctx.isLoading = false;
                    ctx.isAdmin = true;
                    ctx.$set(ctx.forms['main'], 'state', response.data.main);
                    if(response.data.abstract) {
                        ctx.$set(ctx.forms['abstract'], 'state', response.data.abstract);
                    }
                })
                .catch(function(error) {
                    alert(`unable to load edit form: ${error}`);
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .view-wrapper{
        padding-bottom:200px;
        max-width:800px;
        margin:0 auto;
        overflow:hidden;
        @media(max-width:1000px){
            max-width:500px;
        }
        @media(max-width:700px){
            max-width:300px;
        }
        @media(max-width:500px){
            max-width:100%;
        }
    }
    .warntext{
        padding:15px 0;
        text-align:center;
        width:100%;
        color:red;
        font-size:1.2em;
    }
    .btn-primary{
        font-size:1.5em;
        border:1px solid #1172f4;
        color:#1172f4;
        padding:10px 25px;
        border-radius:3px;
        background:none;
        cursor:pointer;
        transition: color 0.5s ease;
        .fa{ margin:0 10px 0 0; }
        &.right{
            float:right;
            .fa{margin:0 0 0 10px;}
        }
        &.loading{
            color:#787878;
            border:1px solid #787878;
            .fa{margin:0;}
        }
        &:hover{
            border:1px solid #114af4;
            color:#114af4;
        }
    }
</style>
